import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IProductXBarcode } from "src/models/Products/Product.models";

interface ProductXBarcodeState {
  productBarcodes: IProductXBarcode[];
  productBarcodeToEdit: IProductXBarcode | null;
}

const initialState: ProductXBarcodeState = {
  productBarcodes: [],
  productBarcodeToEdit: null,
};

const productXBarcodeSlice = createSlice({
  name: "ProductXBarcode",
  initialState,
  reducers: {
    setProductXBarcodeList: (
      state,
      action: PayloadAction<IProductXBarcode[]>
    ) => {
      state.productBarcodes = action.payload;
    },
    concatListProductXBarcode: (
      state: ProductXBarcodeState,
      action: PayloadAction<IProductXBarcode[]>
    ) => {
      state.productBarcodes = [...state.productBarcodes.concat(action.payload)];
    },
    setProductXBarcodeToEdit: (
      state,
      action: PayloadAction<IProductXBarcode | null>
    ) => {
      state.productBarcodeToEdit = action.payload;
    },
    addProductXBarcode: (state, action: PayloadAction<IProductXBarcode>) => {
      state.productBarcodes.push(action.payload);
    },
    updateProductXBarcode: (state, action: PayloadAction<IProductXBarcode>) => {
      let itemIndex = state.productBarcodes.findIndex(
        item => item.barcodeId === action.payload.barcodeId
      );
      if (itemIndex !== -1) state.productBarcodes[itemIndex] = action.payload;
    },
    deleteProductXBarcode: (state, action: PayloadAction<number>) => {
      const newArray = state.productBarcodes.filter(
        item => item.barcodeId !== action.payload
      );
      state.productBarcodes = newArray;
    },
  },
});

export const {
  setProductXBarcodeList,
  concatListProductXBarcode,
  setProductXBarcodeToEdit,
  addProductXBarcode,
  updateProductXBarcode,
  deleteProductXBarcode,
} = productXBarcodeSlice.actions;

export default productXBarcodeSlice.reducer;
